<template>
  <DSUserAvatar
    v-if="normalizedAffix?.avatarUrl"
    :src="normalizedAffix.avatarUrl"
    :size="DS_USER_SIZE.ExtraSmall"
    :status="DS_USER_STATUS.None"
    icon-name="user"
    alt=""
  />
  <DSIcon
    v-else-if="normalizedAffix?.icon"
    :icon="normalizedAffix.icon as DSIconName"
  />
  <DSFlag
    v-else-if="normalizedAffix?.flag"
    :flag="normalizedAffix.flag"
    :size="DS_FLAG_SIZES.Small"
  />
  <span
    v-else-if="normalizedAffix?.text"
    :class="textClasses"
    :data-cy="`${props.baseDataCy}-text`"
  >
    {{ normalizedAffix.text }}
  </span>
</template>

<script setup lang="ts">
import { computed } from "vue";
import DSIcon from "@/src/design_system/primitives/icon/components/DSIcon.vue";
import DSFlag from "@/src/design_system/primitives/flag/components/DSFlag.vue";
import DSUserAvatar from "@/src/design_system/data_display/user/components/DSUserAvatar.vue";
import { DS_BASE_INPUT_CLASSES } from "../constants/classes";
import type { DSIconName } from "@/src/design_system/primitives/icon/types/iconName.generated";
import type { DSBaseInputAffixContentProps } from "@/src/design_system/form_elements/base_input/types/dsBaseInputAffixContent";
import { DS_BASE_INPUT_AFFIX_TYPE } from "@/src/design_system/form_elements/base_input/types";
import { DS_FLAG_SIZES } from "@/src/design_system/primitives/flag/types";
import { DS_USER_SIZE } from "@/src/design_system/data_display/user/types/size";
import { DS_USER_STATUS } from "@/src/design_system/data_display/user/types/status";

const props = defineProps<DSBaseInputAffixContentProps>();

const normalizedAffix = computed(() => {
  if (typeof props.affix === "string") {
    return { icon: props.affix };
  }

  return props.affix;
});

const textClasses = computed(() =>
  props.type === DS_BASE_INPUT_AFFIX_TYPE.Prefix ? DS_BASE_INPUT_CLASSES.PrefixText : DS_BASE_INPUT_CLASSES.SuffixText
);
</script>
